module.exports = __webpack_public_path__ + "img/Nutrilon_MCM_C1_2024__news_01_580x312_001.832bc62f.png";